/**
 * normalizePointsConfig — 매장 포인트 정책의 fail-closed 정규화
 *
 * #285: BE 계약을 위반하는 값(enabled=false, earn_rate 범위 밖 등) 이면
 * `null` 반환 → FE 는 포인트 UI 전체 비활성 처리.
 *
 * @see .claude/specs/SPEC-285-points-ui-gating.md §5.1, §5.2, §7
 */
import type { StorePointsConfig } from '@/lib/api/types';

const isRatio = (v: number): boolean => v >= 0 && v <= 1;

export function normalizePointsConfig(
  raw?: StorePointsConfig | null
): StorePointsConfig | null {
  if (!raw || !raw.enabled) return null;
  if (!isRatio(raw.earn_rate)) return null;
  if (!isRatio(raw.max_use_ratio)) return null;
  return raw;
}
